import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AppWrapper from "./containers/App/App";
// import registerServiceWorker from "./registerServiceWorker";
import 'semantic-ui-css/semantic.min.css';
//import '@fortawesome/fontawesome-free/css/all.css'
// import '@fortawesome/fontawesome-pro/css/all.css'

ReactDOM.render(<AppWrapper />, document.getElementById("root"));
//registerServiceWorker();
